"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Position;
(function (Position) {
    Position["Static"] = "ty-static";
    Position["Absolute"] = "ty-absolute";
    Position["Fixed"] = "ty-fixed";
    Position["Relative"] = "ty-relative";
    Position["Initial"] = "ty-initial";
    Position["Inherit"] = "ty-inherit";
})(Position = exports.Position || (exports.Position = {}));
